import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import type { StepMark } from '../model/first-run';

type StepRowProps = { number: 1 | 2 | 3; mark: StepMark; children: ReactNode };

const DOT_CLASS: Record<StepMark, string> = {
  current: 'bg-accent text-accent-ink',
  done: 'bg-ok-soft text-ok-text',
  next: 'bg-surface-3 text-muted',
};

export function StepRow({ number, mark, children }: StepRowProps) {
  return (
    <div className="grid grid-cols-[32px_minmax(0,1fr)] gap-3.5 border-line py-4.5 not-first:border-t">
      <span
        aria-hidden="true"
        className={cn(
          'inline-flex size-8 items-center justify-center rounded-control font-semibold',
          DOT_CLASS[mark],
        )}
      >
        {mark === 'done' ? '✓' : number}
      </span>
      <div className="flex min-w-0 flex-col gap-3 pt-1.25">{children}</div>
    </div>
  );
}
